export const disableNonScalableOrgActionsOrgs = ['20nYb72jRVmhy3P4SCyuBg'];
export const ADMIN_HOME_V2_REF = 'admin-home-v2';

// LocalStorage keys for enterprise admin home filters
export const FILTER_STORAGE_KEYS = {
  CONTRACTS: 'enterprise-admin-filters:contracts',
  PROGRAMS: 'enterprise-admin-filters:programs',
  TIME_PERIOD: 'enterprise-admin-filters:time-period',
} as const;

// Custom event for notifying filter changes across components
export const FILTERS_CHANGED_EVENT = 'enterprise-admin-filters-changed';

export const TIME_PERIODS = {
  LAST_30_DAYS: 'THIRTY_DAYS',
  LAST_90_DAYS: 'NINETY_DAYS',
  ALL_TIME: 'ALL_TIME',
} as const;

export const TIME_PERIODS_FOR_LOOKER = {
  THIRTY_DAYS: '30',
  NINETY_DAYS: '90',
  ALL_TIME: 'ALL_TIME',
} as const;

// Chart colors using CDS design tokens
export const CHART_COLORS = {
  currentPeriod: 'var(--cds-color-emphasis-quaternary-background-xstrong)',
  previousPeriod: 'var(--cds-color-emphasis-neutral-background-default)',
  growthTrend: 'var(--cds-color-emphasis-secondary-stroke-default)',
  similarOrgsGrowth: 'var(--cds-color-emphasis-tertiary-stroke-default)',
  background: 'var(--cds-color-emphasis-primary-background-xweak)',
  white: 'var(--cds-color-white-0)',
  focusBorder: 'var(--cds-color-interactive-stroke-primary-focus)',
  textPrimary: 'var(--cds-color-grey-975)',
  textSecondary: 'var(--cds-color-grey-600)',
  shadow: 'var(--cds-color-darken-100)',
} as const;

// Highcharts base style configuration
export const HIGHCHARTS_BASE_STYLE = {
  font: 'var(--cds-typography-body-tertiary)',
  letterSpacing: 'var(--cds-letter-spacing-0)',
  color: CHART_COLORS.textSecondary,
} as const;

// Responsive breakpoints for chart configuration
export const CHART_BREAKPOINTS = {
  large: 600,
  medium: 500,
  extraSmall: 300,
} as const;

export const ADD_SKILL_FILTER_VALUE = 'add-skill';
export const CHART_CONTAINER_PADDING = 48;

export const MOCK_DEFAULT_EVENT_DATA = {
  enterprise: {
    organizationSlug: 'test-org-slug',
    contractId: 'test-contract-id',
    programSlug: 'test-program-slug',
  },
};
